





import { defineComponent, PropType } from 'vue';
import { PostModel } from '../../../shared/models/post.model';

export default defineComponent({
  name: 'SearchResultItemPostFooter',
  props: {
    post: { type: Object as PropType<PostModel>, required: true },
  },
});
